export var REACT_RENDER_OP = 'ui.react.render';
export var REACT_UPDATE_OP = 'ui.react.update';
export var REACT_MOUNT_OP = 'ui.react.mount';